<template>
  <div
    class="px-6 flex items-center justify-center"
    style="height: 90px;"
    :style="{
      backgroundImage: `url(${require('./promo-incentive.png')})`,
      backgroundSize: '100% 100%',
    }"
  >
    <div class="text-center">
      <div class="flex items-center justify-center">
        <i
          class="text-xs fa-solid fa-gift"
          style="color: #FF8D9E;"
        />

        <div
          class="ml-3 text-sm uppercase"
          style="color: #FF8D9E;"
        >
          Exclusive Offer
        </div>
      </div>

      <div class="mt-1 text-lg font-bold text-white">
        Save {{ currencySymbol }}50 today when you subscribe to an annual plan
      </div>
    </div>
  </div>
</template>

<script>
import { CURRENCY_SYMBOLS } from '@/constants/currencies';

export default {
  computed: {
    currencyCode() {
      return this.$store.state.currencyCode;
    },
    // in Nuxt need to use currencyMixin
    currencySymbol() {
      return CURRENCY_SYMBOLS[this.currencyCode];
    },
  },
};
</script>
